module.exports = __webpack_public_path__ + "static/img/6.0cf0b37.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/winter/dice/6.png
// module id = NSXP
// module chunks = 2